module.exports = __webpack_public_path__ + "img/addToWalletBankRe.df3b7c34.svg";